import React from 'react'
import { render } from 'react-dom'
import { ThemeProvider, CssBaseline } from '@material-ui/core'
import theme from './theme'
import './index.css'
import SedaApp from './modules/explorer'
import { Curtain } from './modules/explorer/curtain'

const target = document.querySelector('#root')

render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Curtain />
    <SedaApp />
  </ThemeProvider>,
  target
)
